import React from 'react';
import { Box } from '@mui/material';

import Sidebar from '../components/Sidebar';
import RetellCallHistoryComponent from '../components/call-list/RetellCallHistoryComponent';

export const RetellCallHistoryPage = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        minHeight: '100vh',
        width: '100%',
      }}
    >
      <Box
        sx={{
          flexShrink: 0,
          height: '100vh',
          position: 'sticky',
          top: 0,
        }}
      >
        <Sidebar />
      </Box>
      <Box
        sx={{
          flexGrow: 1,
        }}
      >
        <RetellCallHistoryComponent />
      </Box>
    </Box>
  );
};

export default RetellCallHistoryPage;
